module.exports = __webpack_public_path__ + "static/media/SamplePage.bacf127d.png";